import { render, staticRenderFns } from "./UpdateDescriptionModal.vue?vue&type=template&id=5b5946fa&"
import script from "./UpdateDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./UpdateDescriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports